import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { form, FormField, required } from '@angular/forms/signals';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { FieldErrorsComponent } from '../../../../shared/ui/components/field-error/field-error';
import { SettlementsPasswordChangeDto } from '../../dto/settlements-password-change';
import { NfzService } from '../../services/nfz-service';

@Component({
  selector: 'app-settlements-password-change',
  imports: [
    ReactiveFormsModule,
    FormField,
    NzCardModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,

    NzCheckboxModule,
    RouterLink,
    NzFlexModule,
    NzGridModule,
    NzDividerModule,
    NzIconModule,
    NzTagModule,
    CommonModule,
    NzAvatarModule,
    NzDropdownModule,
    FieldErrorsComponent,
  ],
  templateUrl: './settlements-password-change.html',
  styleUrl: './settlements-password-change.scss',
})
export class SettlementsPasswordChange {
  readonly modalRef: NzModalRef<any> = inject(NzModalRef);
  readonly nfzService = inject(NfzService);
  readonly isLoading = signal(false);
  readonly isSubmitting = signal(false);
  readonly submitted = signal(false);
  readonly serviceProviderCode = inject<string>(NZ_MODAL_DATA);
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly messageService = inject(NzMessageService);
  readonly changePasswordModel = signal<SettlementsPasswordChangeDto>({
    serviceProviderCode: this.serviceProviderCode,
    oldPassword: '',
    newPassword: '',
  });

  changePasswordForm = form(this.changePasswordModel, (changePasswordModel) => {
    required(changePasswordModel.oldPassword);
    required(changePasswordModel.newPassword);
  });

  submit() {
    this.submitted.set(true);
    if (!this.changePasswordForm().valid()) {
      return;
    }
    this.isLoading.set(true);
    this.nfzService
      .changeSettlementsPassword(
        this.changePasswordModel().serviceProviderCode,
        this.changePasswordModel().oldPassword,
        this.changePasswordModel().newPassword,
      )
      .subscribe({
        next: () => {
          this.isLoading.set(false);
          this.submitted.set(true);
          this.messageService.success('Hasło zostało zmienione pomyślnie');
          this.modalRef.close();
        },
        error: (error) => {
          console.error('Error changing password:', error);
          this.isLoading.set(false);
        },
      });
  }
}
